<template #content>

    <div class="w-full">
        <div class="field mt-4 flex gap-2">
            <div class="w-4">
                <FloatLabel>
                    <DatePicker 
                        id="data_primeiro_pagamento"
                        v-model="form.data_primeiro_pagamento"
                        class="w-full"
                        dateFormat="dd/mm/yy"
                        showIcon />
                    <label for="data_primeiro_pagamento">Primeiro Pagamento<span class="text-red-500">*</span></label>
                </FloatLabel>
                <div class="text-xs text-red-500">{{ errors['data_primeiro_pagamento'] }}</div>
            </div>

            <div class="w-4">
                <FloatLabel>
                    <InputNumber id="dia_pagamento" v-model="form.dia_pagamento" :min="1" :max="31" fluid />
                    <label for="dia_pagamento">Dia de Pagamento<span class="text-red-500">*</span></label>
                </FloatLabel>
                <div class="text-xs text-red-500">{{ errors['dia_pagamento'] }}</div>
            </div>

            <div class="w-4">
                <InputGroup>
                    <InputGroupAddon>R$</InputGroupAddon>
                    <FloatLabel>
                        <InputNumber id="valor_inicial" v-model="form.valor_inicial" :minFractionDigits="2" :maxFractionDigits="5" fluid />
                        <label for="valor_inicial">Valor Mensalidade<span class="text-red-500">*</span></label>
                    </FloatLabel>
                </InputGroup>
                <div class="text-xs text-red-500">{{ errors['valor_inicial'] }}</div>
            </div>
        </div>
    </div>

</template>
<script>
import FloatLabel from 'primevue/floatlabel';
import InputText from 'primevue/inputtext';
import Select from 'primevue/select';
import InputMask from 'primevue/inputmask';
import Checkbox from 'primevue/checkbox';
import AutoComplete from 'primevue/autocomplete';
import DatePicker from 'primevue/datepicker';
import InputNumber from 'primevue/inputnumber';
import Textarea from 'primevue/textarea';
import Button from 'primevue/button';
import InputGroup from 'primevue/inputgroup';
import InputGroupAddon from 'primevue/inputgroupaddon';
import Panel from 'primevue/panel';

import ClienteListaSelect from '@/page/cliente/ListaSelect.vue';

export default {
    components: { FloatLabel,
                  InputGroup,
                  InputGroupAddon,
                  Button,
                  InputText,
                  InputMask,
                  Select,
                  Textarea,
                  AutoComplete,
                  Checkbox,
                  DatePicker,
                  InputNumber,
                  Panel,

                  ClienteListaSelect,
                },
    props: {
        form: {},
        errors: {},
        permissoes: {},
    },
    emits: ['save','close'],
    data() {
        return {
            isLoading: false,
        }
    },
    watch: {
        /**
         * Sempre que o usuário escolhe/muda o "Primeiro Pagamento", o "Dia de Pagamento"
         * é sincronizado automaticamente com o dia desta data.
         * Se o usuário quiser sobrescrever manualmente depois, basta editar o campo.
         */
        'form.data_primeiro_pagamento'(novo) {
            if (!novo) return;
            const data = novo instanceof Date ? novo : new Date(novo);
            if (Number.isNaN(data.getTime())) return;
            this.form.dia_pagamento = data.getDate();
        },
    },
    mounted() {
    },
    updated() {
    },
    methods: {        
    }
}
</script>

<style>
    .contrato-endereco .p-panel-header {
        padding-bottom: 0;
    }
</style>
